import { hasPermission } from "./permissionUtils";

export function filterNavigationItems(items, perms, options = {}) {
  const userRole = options?.userRole;
  const companyFeatures = options?.companyFeatures;
  const dashboardVariant =
    options?.dashboardVariant === "benchmark" ? "benchmark" : "standard";

  const isAllowed = (item) => {
    if (item.hide) return false;
    if (item.dashboardVariant && item.dashboardVariant !== dashboardVariant)
      return false;
    if (
      Array.isArray(item.allowedRoles) &&
      item.allowedRoles.length > 0 &&
      !item.allowedRoles.includes(userRole)
    ) {
      return false;
    }
    if (
      item.companyFeatureFlag &&
      companyFeatures?.[item.companyFeatureFlag] === false
    ) {
      return false;
    }
    // Opt-in company flags (e.g. allowAssetList): hidden unless explicitly true,
    // so legacy sessions without the flag stay hidden.
    if (
      item.requiredCompanyFeature &&
      companyFeatures?.[item.requiredCompanyFeature] !== true
    ) {
      return false;
    }
    if (item.defaultView) return true;
    if (!item.permissionKey) return true;

    const action = item.requiredAction ?? "view";
    return hasPermission(perms, item.permissionKey, action);
  };

  return items
    .map((item) => {
      const resolvedItem =
        item.benchmarkLink && dashboardVariant === "benchmark"
          ? {
              ...item,
              link: item.benchmarkLink,
              label: item.benchmarkLabel || item.label,
            }
          : item;

      if (!resolvedItem.subItems) return resolvedItem;

      const filteredSub = filterNavigationItems(
        resolvedItem.subItems,
        perms,
        options,
      );
      return { ...resolvedItem, subItems: filteredSub };
    })
    .filter((item) => {
      const hasVisibleChildren = item.subItems?.length > 0;
      if (item.subItems) {
        if (item.hide) return false;
        // show parent if it itself is allowed OR any child is allowed
        return isAllowed(item) || hasVisibleChildren;
      }
      return isAllowed(item);
    });
}
